import React, { useCallback, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { showToast } from "../../../../../../store/actions";
import TemplateBrowser from "../../../TemplateBrowser";
import TemplateService from "../../../../../../service/template";
import { DATA_SOURCE } from "../../../../../../util/Data/DataModeling";
import DSContext from "../DSContext";

export default function UploadTemplate(props) {
  let {
    setOpen,
    type,
    dataTableRef,
    setErrors,
    setOpenErrorLogPopup,
    templateDataRef,
    setTemplateName,
    workspaceName,
    IsDataVaultEnabled,
    fetchENTRequiredInfo,
    fetchDSRequiredInfo,
    tagsRef,
  } = props;
  const { setFields } = useContext(DSContext);
  const dispatch = useDispatch();
  const dataSourceData = useSelector((state) => state.dataSourceData);
  const entititData = useSelector((state) => state.entititData);
  const { status: enStatus, entities } = entititData;
  const { status: dsStatus, dataSources } = dataSourceData;

  //Getting file and folder data
  const getData = useCallback(async () => {
    const templateService = new TemplateService();
    const responseData = await templateService.getData(type);
    templateDataRef.current = responseData;
    return templateService.getAttributeTemplateOptions();
  }, [type]);

  //Download click
  const downloadClick = async (templateId, templateName) => {
    const templateService = new TemplateService();
    templateService.download(templateId, templateName);
  };

  //Delete click
  const deleteClick = async (templateId) => {
    const templateService = new TemplateService();
    return await templateService.delete(templateId);
  };

  //Function to check template is valid of Existing Entity or not
  const checkForValidTemplate = (fileData) => {
    const errors = [];

    // Combine the errors by checking in Main(Modeling) JSON Object
    if (Object.keys(fileData).length === 0) errors.push({ field: "N/A", message: "Template is empty" });
    else if (!fileData?.fields?.length && !fileData?.tags?.length)
      errors.push({ field: "N/A", message: "Template has no attributes or tags." });
    else {
      if (fileData?.fields?.length) {
        fileData.fields.forEach((field) => {
          if (!IsDataVaultEnabled && field.dataVaultKey) {
            errors.push({
              field: field.name,
              message: `Key status will be removed - "${field.name}" is Data Vault key (Data Vault 2.0 feature).`,
              type: "dvModel",
            });
          }
          if (field.referenceTo && field.referenceTo.length > 0) {
            errors.push({
              field: field.name,
              message: IsDataVaultEnabled
                ? `Relationship will be removed - "${
                    field.name
                  }" is a parent to other ${DATA_SOURCE.singular.toLowerCase()}(s)`
                : `Relationship will be removed - ${field.name} (Data Vault 2.0 feature)`,
              type: "referenceTo",
            });
          }
          if (field.referenceFrom && Object.keys(field.referenceFrom).length > 0) {
            if (!IsDataVaultEnabled) {
              errors.push({
                field: field.name,
                message: `Relationship will be removed - ${field.name} (Data Vault 2.0 feature)`,
                type: "referenceFrom",
              });
            } else {
              const referredDataSource = dataSources.find(
                (ds) => ds.name.toLowerCase() === field.referenceFrom.data_source.toLowerCase()
              );
              if (referredDataSource) {
                if (referredDataSource.fields && referredDataSource.fields.length) {
                  const referredField = referredDataSource.fields.find(
                    (refDSField) => refDSField.name.toLowerCase() === field.referenceFrom.field.name.toLowerCase()
                  );
                  if (referredField) {
                    if (!referredField.dataVaultKey) {
                      errors.push({
                        field: field.name,
                        message: `Relationship will be removed - "${referredDataSource.name} | ${field.referenceFrom.field.name}" is not a data vault key`,
                        type: "referenceFrom",
                      });
                    }
                  } else {
                    errors.push({
                      field: field.name,
                      message: `Relationship will be removed - "${referredDataSource.name} | ${field.referenceFrom.field.name}" is missing in "${workspaceName}" workspace`,
                      type: "referenceFrom",
                    });
                  }
                } else {
                  errors.push({
                    field: field.name,
                    message: `No attributes found in "${
                      referredDataSource.name
                    }" ${DATA_SOURCE.singular.toLowerCase()}`,
                    type: "referenceFrom",
                  });
                }
              } else {
                errors.push({
                  field: field.name,
                  message: `Relationship will be removed - "${field.referenceFrom.data_source}" is missing in "${workspaceName}" workspace`,
                  type: "referenceFrom",
                });
              }
            }
          }
          if (
            field.entity_mapping &&
            Object.keys(field.entity_mapping).length &&
            field.entity_mapping.hasOwnProperty("entity") &&
            field.entity_mapping.hasOwnProperty("field")
          ) {
            if (IsDataVaultEnabled && (field.primary_attribute || field.secondary_attribute)) {
              errors.push({
                field: field.name,
                message: `Key status will be removed - "${field.name}" is primary/secondary key (KMK model feature).`,
                type: "kmkModel",
              });
            }
            const mapping = field.entity_mapping;
            const matchedEntity = entities.find(
              (entity) => entity.name.toLowerCase() === mapping?.entity?.toLowerCase()
            );

            //Proceed if mapped entity is exists
            if (matchedEntity) {
              if (matchedEntity.fields && matchedEntity.fields.length) {
                const matchedField = matchedEntity.fields.find(
                  (entityField) => entityField.name.toLowerCase() === mapping.field.toLowerCase()
                );

                //Proceed if mapped field is exists in mapped entity
                if (matchedField) {
                  //Push an error in array if length of mapped field's doesn't match
                  if (matchedField.length !== field.length)
                    errors.push({
                      field: field.name,
                      message: `"${field.name}" attribute's length is "${field.length}" and "${matchedEntity.name}"."${matchedField.name}" attribute's length is "${matchedField.length}"`,
                      type: "entity",
                    });

                  //Push an error in array if type of mapped field's doesn't match
                  if (matchedField.type !== field.type)
                    errors.push({
                      field: field.name,
                      message: `"${field.name}" attribute's type is "${field.type}" and "${matchedEntity.name}"."${matchedField.name}" attribute's type is "${matchedField.type}"`,
                      type: "entity",
                    });
                }
                //Push an error in mapped field doesn't exist in mapped entity
                else
                  errors.push({
                    field: field.name,
                    message: `"${mapping.field}" not found in "${matchedEntity.name}" entity attributes list`,
                    type: "entity",
                  });
              }
              //Push an error in no fields exists in mapped entity
              else {
                errors.push({
                  field: field.name,
                  message: `No attributes found in "${matchedEntity.name}" entity`,
                  type: "entity",
                });
              }
            }
            //Push an error in mapped entity doesn't exist
            else {
              errors.push({ field: field.name, message: `"${mapping.entity}" entity not found`, type: "entity" });
            }
          }

          //Checking if ref source is exists or not else removing consistency dqm rule
          if (
            field?.dqm?.refSource &&
            field?.dqm?.refField &&
            !dataSources.some(
              (source) =>
                source.id === field.dqm.refSource && source.fields.some((_field) => _field.id === field?.dqm?.refField)
            )
          ) {
            errors.push({
              field: field.name,
              message: `Consistency rule will be removed - ${DATA_SOURCE.singular}/fields not found for "${field.name}" attribute.`,
              type: "DQM",
            });
          }
        });
      }
    }
    return errors;
  };

  //Upload file
  const uploadFile = async ({ uploadedFiles }) => {
    const fileData = uploadedFiles[0];
    if (fileData && fileData.name.lastIndexOf(".") > 0) {
      const fileExtension = fileData.name.substring(fileData.name.lastIndexOf(".") + 1, fileData.name.length);
      const fileSize = Math.round(fileData.size / 1024);

      //Check for JSON file validation
      if (fileExtension.toLowerCase() !== "json") {
        dispatch(
          showToast({
            message: "Please upload file having extension .json only.",
            type: "error",
          })
        );
      } else if (fileSize > 10000) {
        // file size greater than 10MB
        dispatch(
          showToast({
            message: "Please upload file having size equal or less than 10MB.",
            type: "error",
          })
        );
      } else {
        const fileName = fileData.name.substring(0, fileData.name.lastIndexOf("."));

        const checkUniqueFileName = templateDataRef.current.some((template) => {
          return template.name === fileName;
        });
        if (checkUniqueFileName)
          dispatch(showToast({ message: "Template with same name is already exist", type: "error" }));
        else {
          const errorMessage = await checkTemplateBeforeUpload(fileData);

          if (errorMessage)
            dispatch(
              showToast({
                message: errorMessage,
                type: "error",
              })
            );
          else {
            // Submit upload file data using Formdata
            const formData = new FormData();
            formData.append("file", fileData);
            formData.append("type", type);
            const templateService = new TemplateService();
            return await templateService.upload(formData);
          }
        }
      }
      return { success: false };
    }
  };

  //Check for Valid JSON String
  function IsJsonString(str) {
    try {
      const json = JSON.parse(str);
      return typeof json === "object";
    } catch (e) {
      return false;
    }
  }

  //Function to check for valid JSON object in Template file before upload and notify user about the warning message
  const checkTemplateBeforeUpload = (fileData) => {
    //Read template data and check for valid Template before upload
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const text = e.target.result;
        let errorMessage = "";

        if (!e.target.result) errorMessage = "Template is empty";
        else if (!IsJsonString(text)) errorMessage = "Template has not valid JSON object";
        else if (
          IsJsonString(text) &&
          (!JSON.parse(text).fields || !JSON.parse(text).fields.length || !Array.isArray(JSON.parse(text).fields))
        )
          errorMessage = "Template has no attributes";
        else {
          const templateFields = JSON.parse(text).fields;
          const notValidFieldObj = templateFields.some((field) => !field.hasOwnProperty("name"));
          if (notValidFieldObj) errorMessage = `Template attribute(s) has no "name" property`;
        }

        resolve(errorMessage);
      };
      reader.readAsText(fileData);
    });
  };

  //Load Template Data in Attribute table on click of "Load" Button
  const loadTemplateData = (templateName) => {
    let infoErrors = [];

    if (templateDataRef.current.length > 0) {
      const selectedTemplate = templateDataRef.current.find(
        (item) => item.name.toLowerCase() === templateName.toLowerCase()
      );

      if (Object.keys(selectedTemplate).length > 0) {
        //Check Whether Template has any conflicts
        infoErrors = checkForValidTemplate(selectedTemplate);
        //Set Errors State and Open Error Log Popup if there is any error
        setErrors(infoErrors);
        if (infoErrors.length) {
          setTemplateName(templateName);
          setOpenErrorLogPopup(true);
        } else {
          dataTableRef.current.resetData();
          tagsRef.current.resetData();
          setFields([]);

          // Before adding fields from template if workspace is DataVault Enabled then remove primary and secondary keys
          if (IsDataVaultEnabled) {
            selectedTemplate.fields.forEach((field) => {
              field.primary_attribute = false;
              field.secondary_attribute = false;
            });
          }

          dataTableRef.current.addRow(selectedTemplate.fields);
          tagsRef.current.setTagsFromParent(JSON.parse(JSON.stringify(selectedTemplate?.tags || [])));

          dispatch(
            showToast({
              message: "Template loaded successfully.",
              type: "success",
            })
          );
        }
      }
      //Close Upload Template Popup
      setOpen(false);
    }
  };

  useEffect(() => {
    if (enStatus === "notFetched") fetchENTRequiredInfo();
  }, [enStatus, fetchENTRequiredInfo]);

  useEffect(() => {
    if (dsStatus === "notFetched") fetchDSRequiredInfo();
  }, [fetchDSRequiredInfo, dsStatus]);

  return (
    <TemplateBrowser
      getData={getData}
      uploadFile={uploadFile}
      deleteClick={deleteClick}
      downloadClick={downloadClick}
      saveClick={loadTemplateData}
      setOpenFileBrowser={setOpen}
      {...props}
    />
  );
}
